import React from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { uploadTrack } from "shihuo-lib/dist/shihuo-lib";

const isAndroid = utils.isAndroid();
const topTagImage = [
  {
    index: 0,
    img: 'https://static.shihuocdn.cn/admin/files/20221017/bcfbb4a2309b146b11e93ee119eac7e5.png',
    color: '#6A5322'
  },
  {
    index: 1,
    img: 'https://static.shihuocdn.cn/admin/files/20221017/946d40a745c8a60540f09b06c894c57b.png',
    color: '#1C3E56'
  },
  {
    index: 2,
    img: 'https://static.shihuocdn.cn/admin/files/20221017/785ac283075d8f02656162558b6e2b01.png',
    color: '#792E2F'
  },
  {
    index: 3,
    img: 'https://static.shihuocdn.cn/admin/files/20221017/02d2a5d5468bb94fbfb3d743710c375f.png',
    color: '#4D5A6D'
  }
]

class PipelineDepreciateTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabItemComponent: [],
      selected: utils.getParams('tab_key') || 0,
      tabFixed: false,
      tabBarHeight: 0,
      tabBarOffsetTop: 0,
      tabName: '',
      scrollHeight: 0,
      tabList: [],
      pageShow: false
    };
    // 滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll',(e)=>{
        this.onScroll();
      });
    }
  }

  async componentDidMount() {
    if (typeof window !== "undefined") {
      setTimeout(() => {
        const tabBarHeight = document.querySelector('.tab-item') && document.querySelector('.tab-item').clientHeight;
        const tabBarOffsetTop = document.querySelector('.tab-item') && document.querySelector('.tab-item').offsetTop;
        this.setState({
          tabBarHeight,
          tabBarOffsetTop
        });
      }, 1000)
    }

    const { selected = 0 } = this.state;
    const { grains } = this.props.config.containerConfig;
    const tabList = [];

    const goods_list = await this.getDepreciateTopData(selected);
    const listItem = {
      tabName: grains[selected].tabTitle.tabName,
      tabIndex: selected,
      list: goods_list || []
    }
    tabList.push(listItem);
    this.setState({
      tabList,
      pageShow: true
    });
    
  }

  // 
  getAllTabData = () => {
    const { grains } = this.props.config.containerConfig;
    grains.forEach(async(item, index) => {
      if (index > 0) {
        const tabList = this.state.tabList;
        const goods_list = await this.getDepreciateTopData(index);
        const listItem = {
          tabName: item.tabTitle.tabName,
          tabIndex: index,
          list: goods_list || []
        }
        tabList.push(listItem);
        this.setState({
          tabList: tabList.sort((a, b) => a.tabIndex - b.tabIndex)
        }); 
      }
    });
  }

  // 获取降价Top列表数据
  getDepreciateTopData = (tab_key) => {
    return new Promise((resolve, reject) => {
      axios({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/goods_price/list',
        method: "get",
        withCredentials: true,
        params: {
          is_all: 1,
          list_type: 1,
          tab_key: tab_key,
          page_id: utils.getPageId()
        },
      }).then(res => {
        const { status, data } = res.data;
        const goods_list = data.goods_list || [];
        resolve(goods_list)
      }).catch((err) => {
        console.log(err);
      });
    });
  }

  handleTabSelect = async(event, item, index) => {
    event.preventDefault();
    if (index == this.state.selected) {
      return;
    }
    const { grains } = this.props.config.containerConfig;
    const navigationBarHeight = this.props.navigationBarHeight;
    const { tabFixed, tabBarOffsetTop } = this.state;
    const newProps = JSON.parse(JSON.stringify(this.props));
    Object.assign(newProps, {
      tabName: item.tabTitle.tabName
    });

    const goods_list = await this.getDepreciateTopData(index);
    const tabList = [];
    const listItem = {
      tabName: grains[index].tabTitle.tabName,
      tabIndex: index,
      list: goods_list || []
    }
    tabList.push(listItem);

    this.setState({
      selected: index,
      tabName: item.tabTitle.tabName,
      tabList
    }, () => {
      tabFixed && tabBarOffsetTop > 0 && window.scrollTo(0, tabBarOffsetTop - navigationBarHeight + 1);
      this.updateNavPostion();
    });

    // 点击埋点
    const options = {
      tab_name: item.tabTitle.tabName,
      lego_page_id: utils.getPageId(),
      legoAb: this.props.abValue,
      h5Url: window.location.href
    }
    uploadTrack({
      pti: {
        id: `lego-sales:tab:${index}`,
        biz: JSON.stringify(options),
        pageOptions: options
      },
    });
  }

  onScroll = () => {
    const navigationBarHeight = this.props.navigationBarHeight;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const depreciateTop = window.document.querySelector('.pipeline-depreciateTop');
    const navOffsetTop = depreciateTop ? depreciateTop.offsetTop - navigationBarHeight : 0;

    const tabFixed = scrollHeight - navOffsetTop > 0;
    if (this.state.tabFixed != tabFixed) {
      this.setState({
        tabFixed
      });
    }
  }

  updateNavPostion = () => {
    // 导航条切换选中后，调整当前导航到居中位置
    const navigationBar = document.querySelector('.tab-scroll');
    const checkedNavItem = document.querySelector(`.tab-item-nav-active`); // 当前选中的导航item
    const navWidth = navigationBar.offsetWidth; // 导航栏宽度
    const checkedItemOffsetLeft = checkedNavItem.offsetLeft; // 元素距离左边距离
    const checkedItemWidth = checkedNavItem.offsetWidth;
    // 需要滚动的距离
    const shouldUpdateScroll = checkedItemOffsetLeft - (navWidth / 2 - checkedItemWidth / 2) - 16;
    if (navigationBar.scrollWidth > navWidth) {
      // 如果导航条可以滚动，执行滚动操作
      navigationBar.scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
      // 顶部固定导航条也执行滚动操作
      document.querySelector('.tab-scroll').scroll({
        top: 0,
        left: shouldUpdateScroll,
        behavior: 'smooth',
      });
    }
  }

  handleItemClick = (item, index) => {
    const { goods_id = '', style_id = '', cate_id = '', sku_id = 0 } = item;
    const options = {
      sort: index,
      name: item.title,
      goods_id,
      style_id,
      cate_id
    };
    const ptiOptions = {
      ptiId: `lego-sales:list:${index}`,
      ptiName: '降价Top100',
      bizExtra: {
        goods_id,
        style_id,
        cate_id,
        goods_sku_id: sku_id,
        tab_name: this.state.tabName
      }
    }
    utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, -1, this.props, false, ptiOptions);
  }

  avgOrderPriceView = (price) => {
    let sparePrice = null
    if (price > 10000) {
      sparePrice = utils.priceConversion(price, 2);
    }
     if (sparePrice && sparePrice.list) {
       let sparePriceList = sparePrice.list
      return <p className="price-text">¥{sparePriceList[0]}{sparePriceList[1] ? `.${sparePriceList[1]}`:''}{sparePrice.unit}</p>
     } else {
      return (
        <p className="price-text">¥{price}</p>
      ) 
     } 
  }

  nowPriceView = (value, grains, selected) => {
    let sparePrice = null
    if (value.now_price > 1000) {
      sparePrice = utils.priceConversion(value.now_price, 2);
    }

     if (sparePrice && sparePrice.list) {
      let sparePriceList = sparePrice.list
      return (
        <div className='nowPriceView'>
          <span 
            style={{
              fontSize: px2rem('12px'),
              marginTop: px2rem('4px')
            }}
          >¥</span>
          <span 
            style={{
              fontSize: px2rem('18px'),
            }}
          >{sparePriceList[0]}</span>
          {
            sparePriceList[1] && (
              <span
                style={{
                  fontSize: px2rem('13px'),
                  marginTop: px2rem('2px')
                }}
              >.{sparePriceList[1]}</span>
            )}
          {
            sparePrice.unit && (
              <span
                style={{
                  fontSize: px2rem('12px'),
                  marginTop: px2rem('3px')
                }}
              >{sparePrice.unit}</span>
            )
          }
          <span className="desc" style={{top: px2rem('2px')}}>{value.tag_name || grains[selected].tabInfoConfig.productTag}</span>
        </div>
      )
     } else {
      return (
        <div>
          <span className="rmb">¥</span>
          <span className="price">{value.now_price}</span>
          <span className="desc">{value.tag_name || grains[selected].tabInfoConfig.productTag}</span>
        </div>
      )
     }
  }

  render() {
    const { osVersion = '' } = this.props;
    const { selected, tabFixed, tabBarHeight, tabList, pageShow } = this.state;
    const { moduleMarginTop, tabType, fontColor } = this.props.config.baseConfig;
    const { grains } = this.props.config.containerConfig;
    if (!grains || grains.length <= 0 || !pageShow) {
      return null;
    }
    let tabItemClass = "tab-item type-text", tabScroller = false, adaptive = false;
    if (!isAndroid && (osVersion == '15.1' || osVersion == '15.2')) {
      adaptive = true
    }
    adaptive && (tabItemClass += tabFixed ? ' fixed' : '');
    if (grains.length >= 4) {
      tabItemClass += ' scroller';
      tabScroller = true;
    }
    return (
      <div
        className="pipeline-depreciateTop"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${moduleMarginTop}px`,
        }}
      >
        {
          adaptive ? (
            tabFixed && <div ref={ref => this.tabItemPlaceholderRef = ref} className="placeholder tab-item-placeholder" style={{height: tabBarHeight}}></div>
          ) : (
            <div ref={ref => this.tabItemPlaceholderRef = ref} className="placeholder tab-item-placeholder"></div>
          )
        }
        <div
          className={tabItemClass}
          style={{
            top: this.props.navigationBarHeight,
            backgroundColor: this.props.backgroundColor
          }}
        >
          <ul className={tabScroller ? 'tab-scroll custom-padding' : 'tab-scroll'}>
            {
              grains.map((item, index) => {
                let tabNavClass = "";
                tabNavClass = selected == index ? 'tab-item-nav tab-item-nav-active active' : 'tab-item-nav';
                tabNavClass += tabScroller ? ' customWidth' : ' autoWidth'
                return (
                  <li
                    className={tabNavClass}
                    key={`tab-item-nav-${index}`}
                    onClick={(event) => this.handleTabSelect(event, item, index)}
                  >
                     <p 
                      style={{
                        color: selected == index ? fontColor : fontColor,
                        opacity: selected == index ? 1 : .7,
                      }}
                    >
                      {item.tabTitle.tabName}
                    </p>
                    {selected === index && <p className="underline" style={{backgroundColor: fontColor}}></p>}
                  </li>
                )
              })
            }
          </ul>
        </div>
        <div className="tab-item-content">
          {
            tabList.map((item, index) => {
              return (
                <ul className={selected == index ? 'tab-content' : 'tab-content'} key={`tab-content-${index}`}>
                  {
                    item.list.map((value, key) => {
                      let topTagImg = '', topTagColor = '';
                      if (key <= 3) {
                        topTagImg = topTagImage[key].img;
                        topTagColor = topTagImage[key].color;
                      } else {
                        topTagImg = topTagImage[3].img;
                        topTagColor = topTagImage[3].color;
                      }
                      return (
                        <li key={`list-item-${key}`} onClick={() => this.handleItemClick(value, key)}>
                          <div className={isAndroid ? 'top-tag android' : 'top-tag ios'} style={{backgroundImage: `url(${utils.formatImgUrl(topTagImg, this.props.webpSupport)})`, backgroundSize: "contain", color: topTagColor}}>
                            TOP
                            <p style={{color: topTagColor}}>{key + 1 < 10 ? `0${key + 1}` : key + 1}</p>
                          </div>
                          <div className="item-img">
                            <LazyLoadImage
                              width={130}
                              height={130}
                              src={utils.formatImgUrl(value.pic, this.props.webpSupport)}
                            />
                            <div className="mask"></div>
                          </div>
                          <div className="item-info">
                            <p className="name" style={{WebkitBoxOrient: "vertical"}}>{value.title}</p>
                            <div className="price-info">
                              <div className={isAndroid ? 'sale-price android' : 'sale-price ios'}>
                                直降 <p>¥{value.price_off}</p>
                              </div>
                              <div className="price">
                                {this.avgOrderPriceView(value.avg_order_price)}
                                <p className="tips">{value.avg_order_price_text}</p>
                              </div>
                              <p className="desc">即将恢复</p>
                            </div>
                            <div className="btn-info">
                              {this.nowPriceView(value, grains, selected)}
                              <div className="buy-btn">去抢购</div>
                            </div>
                          </div>
                        </li>
                      )
                    })
                  }
                </ul>
              )
            })
          }
          <div className="bottom-desc">
            <div className="left-line" />
            <span className="center-desc">没有更多了</span>
            <div className="right-line" />
          </div>
        </div>
      </div>
    );
  }
}

PipelineDepreciateTop.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineDepreciateTop };
export default PipelineDepreciateTop;



// WEBPACK FOOTER //
// ./components/pipeline-depreciateTop/index.js